import { ROUTES } from 'views/Configure/stubs';

export default {
  CONFIGURE: ROUTES.HOME,
  RETURN_MANAGEMENT: ROUTES.RETURN_MANAGEMENT,
  HOME: ROUTES.ADDITIONAL_FEATURES
};
